export default function loadingDataSelector(func) {
  let loadingReducer = func((state) => state.loadingReducer);
  return loadingReducer;
}
